import { ExportJobDestinationType, ExportJobStatus, PublishedDocEnvironment, } from "@supernova-studio/model";
import { z } from "zod";
export const DTOExportJobsListFilter = z.object({
    exporterId: z.string().optional(),
    designSystemVersionId: z.string().optional(),
    createdByUserId: z.string().optional(),
    status: ExportJobStatus.optional(),
    scheduleId: z.string().optional(),
    designSystemId: z.string().optional(),
    themeId: z.string().optional(),
    brandId: z.string().optional(),
    docsEnvironment: PublishedDocEnvironment.optional(),
    destinations: z
        .union([z.string(), z.array(z.string())])
        // Accept a single value, an array, or a comma-separated list
        .transform((v) => (Array.isArray(v) ? v : v.split(",")))
        .pipe(z.array(ExportJobDestinationType))
        .optional(),
});
